<div class="flex flex-col min-h-screen">
  <h1 class="text-2xl font-bold text-center mb-8 mt-5 text-green-500">
    สมัครสมาชิกสำเร็จ !
  </h1>
  <div class="flex justify-center">
    <img
      class="h-40 w-60 object-contain"
      src="images/asset8-25.png"
      alt="element"
    />
  </div>
  <!-- กล่องรวม จัดให้อยู่กลาง -->
  <div class="w-full flex justify-center">
    <div class="w-100">
      <!-- กำหนดความกว้างให้เท่ากัน -->
      <div class="mt-7 items-center">
        <label class="block text-green-500 text-lg font-bold text-center">
          ขอขอบพระคุณ
        </label>
        <div class="mt-5">
          <label class="block text-gray-500 text-lg font-bold text-center">
            โปรดปฎิบัติตามกฏระเบียบของพื้นที่จอด
          </label>
          <label class="block text-gray-500 text-lg font-bold text-center">
            และชำระค่าบริการสมัครสมาชิกภายใน 24 ชม
          </label>
        </div>
      </div>
    </div>
  </div>
  <footer class="px-4 pb-6 mt-10">
    <div class="flex flex-col space-y-5">
      <div>
        <button
          class="flex flex-row items-center justify-center text-center w-full border rounded-xl outline-none py-2.5 bg-green-500 border-none text-white text-xl shadow-sm"
          (click)="closed()"
          >
          ตกลง
        </button>
      </div>
      <!-- <div>
        <button
          class="flex flex-row items-center justify-center text-center w-full border rounded-xl outline-none py-2.5 bg-gray-500 border-none text-white text-xl shadow-sm"
        >
          ดูประวัติการชำระเงิน
        </button>
      </div> -->
    </div>
  </footer>
</div>
